export const PRIME_TOP_NAV_CLASS =
  'bg-[linear-gradient(to_left_in_oklch,color-mix(in_oklch,var(--prime)_22%,var(--card))_0%,color-mix(in_oklch,var(--prime)_10%,var(--card))_25%,color-mix(in_oklch,var(--prime)_4%,var(--card))_50%,transparent_75%)] border-[color-mix(in_oklch,var(--prime)_45%,transparent)] shadow-[inset_40px_0_60px_-60px_color-mix(in_oklch,var(--prime)_30%,transparent),inset_-40px_0_60px_-60px_color-mix(in_oklch,var(--prime)_30%,transparent)]'

/** Crown-tile watermark overlay (sibling div, full-cover, pointer-events-none). */
export const PRIME_TOP_NAV_PATTERN_CLASS = 'prime-crown-pattern'

/** Active Prime-toggle button: neutral surface, crisp gold ring + soft halo. */
export const PRIME_BUTTON_ACTIVE_CLASS =
  'shadow-[0_0_0_1px_color-mix(in_oklch,var(--prime)_70%,transparent),0_0_12px_-2px_color-mix(in_oklch,var(--prime)_45%,transparent),0_6px_16px_-8px_color-mix(in_oklch,var(--prime)_35%,transparent)]'

/** Prime chip ring: thin gold outline only. */
export const PRIME_CHIP_RING_CLASS = 'shadow-[0_0_0_1px_color-mix(in_oklch,var(--prime)_45%,transparent)]'
